// © Copyright 2026 Emman Consulting SAS
// ─── AUTH & SECURITY UTILS ───────────────────────────────────────────────
import DOMPurify from 'dompurify';

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const MAX_LOGIN_ATTEMPTS = 5;
const RATE_LIMIT_WINDOW = 15 * 60 * 1000; // 15 minutes

export const sanitizeInput = str => DOMPurify.sanitize(str || "", { ALLOWED_TAGS: [] }).trim().slice(0, 100);

export const checkRateLimit = () => {
  const attempts = JSON.parse(localStorage.getItem("figurix_auth_attempts") || "[]");
  const now = Date.now();
  const valid = attempts.filter(t => now - t < RATE_LIMIT_WINDOW);
  localStorage.setItem("figurix_auth_attempts", JSON.stringify(valid));
  return valid.length < MAX_LOGIN_ATTEMPTS;
};

export const recordAttempt = () => {
  const attempts = JSON.parse(localStorage.getItem("figurix_auth_attempts") || "[]");
  attempts.push(Date.now());
  localStorage.setItem("figurix_auth_attempts", JSON.stringify(attempts));
};

export const vibrate = (ms = 30) => { try { navigator.vibrate?.(ms); } catch (e) {} };
